import ColorHash from "color-hash";

export const colorHash = new ColorHash({
  hue: [{ min: 220, max: 320 }],
  lightness: [0.65],
  saturation: 0.8,
});

type RGBColor = [number, number, number];

// Define an array of avatar background colors using the new theme palette
const avatarBackgroundColors: RGBColor[] = [
  [12, 110, 252], // Primary Blue (#0C6EFC)
  [250, 173, 77], // Warning Orange (#FAAD4D)
  [0, 132, 99], // Success Green (#008463)
  [223, 49, 49], // Destructive Red (#DF3131)
  [127, 34, 117], // Secondary Purple (#7F2275)
  [103, 79, 230], // Violet (#674FE6)
  [255, 112, 85], // Accent Coral (#FF7055)
  [12, 110, 252], // Primary Blue (repeat)
  [0, 132, 99], // Success Green (repeat)
  [103, 79, 230], // Violet (repeat)
  [250, 173, 77], // Warning Orange (repeat)
];

function isBright(color: RGBColor): boolean {
  const [r, g, b] = color;
  const L = (0.2126 * r) / 255 + (0.7152 * g) / 255 + (0.0722 * b) / 255;
  return L > 0.6;
}

export const getRandomAvatarColor = (str: string) => {
  const strSum = str.split("").reduce((acc, val) => acc + val.charCodeAt(0), 0);
  const randomIndex = strSum % avatarBackgroundColors.length;
  const color = avatarBackgroundColors[randomIndex];
  const [r, g, b] = color;
  return { color: `rgb(${r}, ${g}, ${b})`, requiresDarkText: isBright(color) };
};

export const generateGradient = (s: string): string => {
  const s1 = s.substring(0, s.length / 2);
  const s2 = s.substring(s.length / 2);
  const c1 = colorHash.hex(s1);
  const c2 = colorHash.hex(s2);

  return `linear-gradient(45deg, ${c1}, ${c2})`;
};
